import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Toolbar, Button } from '@material-ui/core';
import { useState, useEffect } from 'react';

import AuthService from '..//api/auth.service';

import './Navbar.css';

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
}));

function Navbar() {
  const classes = useStyles();
  const [currentUser, setCurrentUser] = useState(undefined);

  useEffect(() => {
    const user = AuthService.getCurrentUser();

    if (user) {
      setCurrentUser(user);
    }
  }, []);

  const logOut = () => {
    AuthService.logout();
    setCurrentUser(undefined);
  };

  return (
    <div>
      <AppBar className={classes.appBar} position="fixed">
        <Toolbar>
          <Button component={Link} to="/" color="inherit">
            Home
          </Button>
          {currentUser ? (
            <>
              <Button component={Link} to="/flashcards" color="inherit">
                Flashcards
              </Button>
              <Button component={Link} to="/card-types" color="inherit">
                Card Types
              </Button>
              <Button component={Link} to="/training" color="inherit">
                Training
              </Button>
              <Button component={Link} to="/statistic" color="inherit">
                Statistic
              </Button>
              <div style={{ marginLeft: 'auto' }}>
                <Button component={Link} to="/profile" color="inherit">
                  {currentUser.username}
                </Button>
                <Button
                  onClick={logOut}
                  component={Link}
                  to="/login"
                  color="inherit"
                >
                  LogOut
                </Button>
              </div>
            </>
          ) : (
            <div style={{ marginLeft: 'auto' }}>
              <Button component={Link} to="/login" color="inherit">
                Log-In
              </Button>
              {/* <Button component={Link} to="/register" color="inherit">
                Sign-Up
              </Button> */}
            </div>
          )}
        </Toolbar>
      </AppBar>
      <Toolbar />
    </div>
  );
}

export default Navbar;
